<template>
  <div>
    <el-card class="mb16">
      <table-list :show-page="false" :data="[recipe]">
        <el-table-column align="center" :label="$t('编号')" prop="num" />
        <el-table-column align="center" :label="$t('图片')">
          <template v-slot="{row}">
            <preview-img :img-url="row.cover" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('名称')" prop="name" />
        <el-table-column align="center" :label="$t('发布者编号')" prop="userNum" />
        <el-table-column align="center" :label="$t('发布者昵称')" prop="username" />
        <el-table-column align="center" :label="$t('评论次数')" prop="commentCount" />
      </table-list>
    </el-card>

    <el-card>
      <template #header>
        <h4>{{$t('评价详情')}}</h4>
      </template>

      <el-form size="small" inline>
        <el-form-item :label="$t('编号')">
          <el-input v-model="searchForm.num" :placeholder="$t('编号')" />
        </el-form-item>
        <el-form-item :label="$t('评价内容')">
          <el-input v-model="searchForm.content" :placeholder="$t('评价内容')" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
          <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
        </el-form-item>
      </el-form>

      <div class="btn-row">
        <el-button type="danger" size="small" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
      </div>

      <table-list
          ref="list"
          :data="tableData"
          :search-params="searchForm"
          @selection-change="selection = $event"
          :request-params="{cookbookNum: $route.query.num}"
          @query="handleSearch">
        <el-table-column align="center" type="selection" width="50" />
        <el-table-column align="center" :label="$t('编号')" prop="num" />
        <el-table-column align="center" :label="$t('评论者编号')" prop="userNum" />
        <el-table-column align="center" :label="$t('评论者昵称')" prop="username" />
        <el-table-column align="center" :label="$t('评价内容')" prop="content" />
        <el-table-column align="center" :label="$t('获赞数')" prop="likeCount" />
        <el-table-column align="center" :label="$t('评论时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('操作')">
          <template v-slot="{row}">
            <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </template>
        </el-table-column>
      </table-list>
    </el-card>

  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "RecipeCmtList",
  components: {PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
      // 菜谱数据
      recipe: {}
    }
  },
  methods: {
    // 菜谱详情
    async loadRecipeDetail() {
      try {
        let res = await request(this.$api.cookbook.detail, this.$route.query);
        this.recipe = res.cookbook;
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.cookbookComment.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.cookbookComment.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.cookbookComment.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {
    this.loadRecipeDetail();
  }
}
</script>

<style scoped>

.btn-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}


</style>
